/**
 * Created by filatov on 30.10.2015.
 */
import $ from 'jquery'

export default function ChartTypeSelector(){}

ChartTypeSelector.prototype.init = function(containerId, chartType, changeCallback){
    const self = this;
    this.selectedChartType = chartType;
    this.containerId = "#" + containerId;
    $(this.containerId ).find("span").removeClass("checked");

    $(this.containerId ).find("#"+chartType ).addClass("checked");


    $(this.containerId).find("span").off("click").click( function(e) {
        if ($(e.target ).hasClass("checked"))
            return false;
        $(self.containerId ).find("span").removeClass("checked");
        $(e.target).addClass("checked");
        self.selectedChartType = $(e.target ).attr("id");
        if(changeCallback)
            changeCallback();
    });

    return this;
};

ChartTypeSelector.prototype.getChartType = function(){
   return this.selectedChartType;
};




// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartTypeSelector.js